var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Select",
    {
      ref: "pSelector",
      staticStyle: { width: "200px", "margin-left": "20px" },
      attrs: { filterable: "", clearable: "", "filter-by-label": true },
      on: { "on-change": _vm.handleProductChange },
      model: {
        value: _vm.selectedProductId,
        callback: function ($$v) {
          _vm.selectedProductId = $$v
        },
        expression: "selectedProductId",
      },
    },
    _vm._l(_vm.productList, function (item) {
      return _c(
        "Option",
        { key: item.productUuid, attrs: { value: item.productUuid } },
        [_vm._v(_vm._s(_vm.getOptionLabel(item)))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }